import React, { ReactNode } from "react";

export default function BoxWrapper({
  className = "",
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={`bg-white rounded-4 shadow-sm my-3 rounded-top ${className}`}
    >
      {children}
    </div>
  );
}
